import { AppRestClient } from "@/util/rest/clients/app-rest-client";
import { z } from "zod";
import { ZodExtended } from "@/data/zod.extended";
import { ProfileDemoModels } from "./profileDemo.models";
import { CommonModels } from "@/data/common/common.models";

export namespace ProfileDemoApi {
export const getProfile = () => { 
    return AppRestClient.get( 
        { resSchema: ProfileDemoModels.DemoProfileResponseDtoSchema }, 
        `/profile-demo/profile`,
        
    )
};

export const getAnalyticsGrade = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsGradeResponseDtoSchema }, 
        `/profile-demo/analytics/grade`,
        
    )
};

export const getAnalyticsSkillDiagram = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsSkillDiagramResponseDtoSchema }, 
        `/profile-demo/analytics/skill-diagram`,
        
    )
};

export const getAnalyticsCompletion = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsCompletionResponseDtoSchema }, 
        `/profile-demo/analytics/completion`,
        
    )
};

export const getAnalyticsActionPriorities = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsActionPrioritiesV2ResponseDtoSchema }, 
        `/profile-demo/analytics/action-priorities`,
        
    )
};

export const getAnalyticsStrengthWeaknesses = () => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.ProfileAnalyticsStrengthsWeaknessesResponseDtoSchema }, 
        `/profile-demo/analytics/strength-weaknesses`,
        
    )
};

export const getPast = (limit: number, order?: string, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: ProfileDemoModels.ProfileDemoGetPastResponseSchema }, 
        `/profile-demo/live-shows/past`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getUpcoming = (limit: number, order?: string, page?: number, cursor?: string, ) => { 
    return AppRestClient.get( 
        { resSchema: ProfileDemoModels.ProfileDemoGetUpcomingResponseSchema }, 
        `/profile-demo/live-shows/upcoming`,
        {
    params: {
        order: ZodExtended.parse(z.string().nullish(), order, { type: "query", name: "order" })
, 
        limit: ZodExtended.parse(z.number().gte(1).lte(100).default(10), limit, { type: "query", name: "limit" })
, 
        page: ZodExtended.parse(z.number().nullish(), page, { type: "query", name: "page" })
, 
        cursor: ZodExtended.parse(z.string().nullish(), cursor, { type: "query", name: "cursor" })
, 
    },
}
    )
};

export const getCurrent = () => { 
    return AppRestClient.get( 
        { resSchema: ProfileDemoModels.ProfileDemoGetCurrentResponseSchema }, 
        `/profile-demo/live-shows/current`,
        
    )
};

export const findById = (id: string, ) => { 
    return AppRestClient.get( 
        { resSchema: CommonModels.LiveShowResponseDtoSchema }, 
        `/profile-demo/live-shows/${id}`,
        
    )
};

export const finish = () => { 
    return AppRestClient.post( 
        { resSchema: z.void() }, 
        `/profile-demo/finish`,
        
    )
};

}
